export interface AppEnvironment {
  name: Environments;
  production: boolean;
  whitelabel: boolean;
  productName: string;
  productBaseUrl: string;
  redirectUrl: string;
  domain: EnvironmentDomains;
  openAIKey?: string;
  openAIModel?: string;
}

export enum Environment {
  local = 'local',
  dev = 'dev',
  staging = 'staging',
  sandbox = 'sandbox',
  production = 'production',
}

export enum EnvironmentDomain {
  dev = 'https://api.zero.z1.wtf',
  kitchen = 'https://api.kitchen.z1.wtf',
  sandbox = 'https://api.sandbox.inqud.com',
  production = 'https://api.inqud.com',
  dev_whitelabel = 'https://api.whitelabel.zero.z1.wtf',
  kitchen_whitelabel = 'https://api-whitelabel.kitchen.z1.wtf',
  production_whitelabel = 'https://api.allcore.io',
}

export const EnvironmentRedirectUrl = {
  dev: 'https://app.zero.z1.wtf',
  kitchen: 'https://app.kitchen.z1.wtf',
  sandbox: 'https://app.sandbox.inqud.com',
  production: 'https://app.inqud.com',
  local: 'https://localhost:4200',
  dev_whitelabel: 'https://allcore.io',
  kitchen_whitelabel: 'https://allcore.io',
  production_whitelabel: 'https://allcore.io',
};

export type Environments =
  | Environment.local
  | Environment.dev
  | Environment.staging
  | Environment.sandbox
  | Environment.production;

export type EnvironmentDomains =
  | EnvironmentDomain.dev
  | EnvironmentDomain.kitchen
  | EnvironmentDomain.sandbox
  | EnvironmentDomain.production
  | EnvironmentDomain.dev_whitelabel
  | EnvironmentDomain.kitchen_whitelabel
  | EnvironmentDomain.production_whitelabel;
